import store from '../store/index'

// import { ucLogout } from '@/api/user'
// 使用方法getQueryString('token')
export function getQueryString(key) {
  const reg = new RegExp('(^|&)' + key + '=([^&]*)(&|$)', 'i')
  const urlObj = window.location
  var r =
    urlObj.href.indexOf('#') > -1
      ? urlObj.hash.split('?')[1].match(reg)
      : urlObj.search.substr(1).match(reg)
  if (r != null) return unescape(r[2])
  return null
  // if (r != null) return decodeURI(r[2]); return null
}

// export function getParamFromUrl(key, url) {
//   if (!url) url = location.href
//   key = key.replace(/[[]/, '\\[').replace(/[\]]/, '\\]')
//   var regexS = '[\\?&]' + key + '=([^&#]*)'
//   var regex = new RegExp(regexS)
//   var results = regex.exec(url)
//   return results == null ? null : results[1]
// }

export function getParamFromUrl(key, url = window.location.href) {
  // 微应用迁移后路由变更为hash模式 需要用正则去匹配兼容历史逻辑
  // if (!key || !window.location.search) return
  // const urlParams = new URLSearchParams(window.location.search)
  // return urlParams.get(key)
  const reg = new RegExp(`[?/&](${key}=)([^?/&#]*)[/&\0]*`, 'i')

  if (url.match(reg)) return RegExp.$2
  return undefined
}

// 从 url 截取 ticket
export function getUrlTicketAndSave() {
  if (getPersonToken()) {
    return 'token'
  } else if (getLegalTicket()) {
    // 法人
    return 'ticket'
  }
  return ''
}

function getLegalTicket() {
  let ticket = ''
  ticket = getParamFromUrl('gxdjkey')
  if (!ticket) return ticket
  saveTicket(ticket)
  return ticket
}

function getPersonToken() {
  let token = ''
  token = getParamFromUrl('gxdjpersonkey')
  if (!token) return token
  saveToken(token)
  return token
}

function saveTicket(ticket) {
  store.commit('user/SET_USER_TICKET', ticket)
  store.commit('user/SET_IS_TOKEN_EXPIRE', false)
}

function saveToken(token) {
  store.commit('user/SET_USER_TOKEN', token)
  store.commit('user/SET_IS_TOKEN_EXPIRE', false)
}

export async function getAndSaveDistrictIdFromUrl() {
  let areaId = getParamFromUrl('areaId')
  if (areaId && areaId !== 'undefined') {
    await store.dispatch('user/getMappingAreaId', { areaId, type: 1 })
    return areaId
  } else {
    return ''
  }
}

// 用法： formatDate(new Date(),'yyyy年MM月dd日')
export function formatDate(oldDate, fmt) {
  let date = new Date()
  if (typeof oldDate === 'string' || typeof oldDate === 'number') {
    date = new Date(+oldDate)
  } else {
    date = oldDate
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  }
  function padLeftZero(str) {
    return ('00' + str).substr(str.length)
  }
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + ''
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : padLeftZero(str))
    }
  }
  return fmt
}

// 将城市和区域ID从 数组中取出，如果融资期限是选择器的，则将输入的融资期限字段设空
export function formatSubmitField(form) {
  let guaranteeMeansIds = form.guaranteeMeansIds
  if (Array.isArray(guaranteeMeansIds)) {
    guaranteeMeansIds = guaranteeMeansIds.sort().join(',')
  }
  return {
    ...form,
    cityId: form.enterpriseAreaIds[0],
    districtId: form.enterpriseAreaIds[1],
    timeLimit: form.termRangeId ? form.timeLimit : '',
    guaranteeMeansIds
  }
}

// 提交融资期限及提交订单时，同步地区更变到地区选择器
export function syncCityInfo({ vm, fullAreaList, cityId, districtId }) {
  // 根据 cityId 从全城市列表中找
  const matchedCity = fullAreaList.find(item => {
    return item.id === cityId
  })
  // 根据 districtId 从城市区域列表中找
  const matchedDistrict = matchedCity.districtList.find(item => {
    return item.id === districtId
  })
  vm.$store.commit('user/SET_CITY_INFO', {
    city: matchedCity,
    district: matchedDistrict,
    areaId: matchedDistrict.id
  })
}

// 将数值转换为会计格式
export function toThousandsFormates2(num) {
  // 判断传进来的数字是否为非空数字
  if (!isNaN(parseFloat(num))) {
    var newNum = Number(Number(num).toFixed(2)).toLocaleString('zh', { minimumFractionDigits: 2 })
    return newNum
  } else {
    return ''
  }
}

export function openBase64InNewWindow(base64) {
  const img = document.createElement('img')
  img.src = base64
  img.style.top = '0'
  img.style.bottom = '0'
  img.style.position = 'absolute'
  img.style.maxHeight = '100vh'
  img.style.left = '0'
  img.style.right = '0'
  img.style.margin = 'auto'
  const newWindow = window.open('', '_blank')
  newWindow.document.body.style.margin = 0
  newWindow.document.body.appendChild(img)
  newWindow.document.title = '图片预览'
}

/**
 * 官方给出的退出登录的方法是通过访问地址：https://portal.zjzwfw.gov.cn/uc/unifiedLogout
 * 访问之后浙江政务网会是退出状态，页面停留在政务网的登录页面，因为没有提供回调参数无法返回页面上一次页面
 * 以下退出登录方法是参考浙江政务网自身退出登录代码而实现
 * 已经过多次验证 法人身份可使用redirectUrl参数退出后返回指定页面，个人身份无效
 * 个人使用jsonp请求：https://portal.zjzwfw.gov.cn/uc/logout 地址可以成功退出
 */
export async function handleLogout(needLogin) {
  // const userType = store.state.user.userType
  const pathname = needLogin ? `${location.pathname}#home` : location.pathname

  const backUrl = encodeURIComponent(`${window.location.origin}${pathname}`)
  handleClean()
  window.location.href = `https://portal.zjzwfw.gov.cn/uc/unifiedLogout?redirectUrl=${backUrl}`
}
export async function handleClean() {
  store.commit('user/SET_IS_TOKEN_EXPIRE', true)
  store.commit('user/CLEAN_USER_INFO')
}
